import { useRenderReadyOffersRewardsEnabled } from 'experiments/use-render-ready-offers-rewards-experiment';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

/**
 * Gates the render-ready loyalty-service offers path.
 *
 * - `enabled`: render the new `OffersPage`. Requires the LD kill-switch on, a
 *   unified-menu store, and the Amplitude experiment in treatment.
 * - `eligibleForExposure`: the user would experience a difference between arms
 *   (kill-switch on + unified menu), independent of their assigned variant. Use
 *   this to drive exposure logging so both control and treatment are recorded.
 */
export const useEnableLoyaltyServiceOffers = () => {
  const flagEnabled = useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_SERVICE_OFFERS);
  const isUnifiedMenuEnabled = useEnableUnifiedMenu();
  const isExperimentEnabled = useRenderReadyOffersRewardsEnabled();

  const eligibleForExposure = flagEnabled && isUnifiedMenuEnabled;

  return {
    enabled: eligibleForExposure && isExperimentEnabled,
    eligibleForExposure,
  };
};
